import { computed } from 'mobx'

import { BlockModel } from '@client/components/Block/model'

export default class DividerModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    this.editor = editor

    this.settings.set({ ...data.settings })
  }

  @computed get allColors() {
    const s = this.settings.values

    const colors = [
      s.color,
    ]

    return colors.filter(Boolean)
  }
}

export const NULL = new DividerModel()
